(function ($, Global) {
	var LandingPage = function (model) {
		this.model = model;
	}

	LandingPage.prototype.initEvents = function () {
		this.publishers();
	}

	LandingPage.prototype.publishers = function () {
		var self = this;

		$(document).ready(function () {
			if ($('.landing-box.justAuthTrigger').exists()) {
				$("a.btn-landing").trigger("click");
			}
		});

		$(document).on('click', '.btn-landing', function () {
			var heightNav = $('.nav-fixed').outerHeight();

			$('html, body').animate({
				scrollTop: $('.btn-landing').offset().top - heightNav * 2
			}, 'slow');
		});

		$(document).on('click', '.action-pme', function () {
			$(".pme-empty, .pme-payment").removeClass('hidden');
			$(".offers").addClass('hidden');
			$(".landing-title").addClass('hidden');
            $(".sous-titre-landing").addClass('hidden');
            $("hr").addClass('hidden');
		});

        $(document).on('click', '.cancel-pme', function () {
            if ($("#poool-widget").exists() && Global.Access) {
                $("#poool-widget").removeClass('hidden');
                $(".landing-box").addClass('hidden');
            } else {
                $(".pme-empty, .pme-payment").addClass('hidden');
                $(".offers").removeClass('hidden');
                $(".landing-title").removeClass('hidden');
                $(".sous-titre-landing").removeClass('hidden');
                $("hr").removeClass('hidden');
            }
			
		});

		$(document).on('click', '#achatArticle', function () {
			var data = $('#achatArticle').data("article");
			self.model.buyArticle(data);
        });

        $(document).on('click', '.landing-box .btn-connexion', function() {
            $('.landing-box .form-login').addClass('in');
            $(this).parent().addClass('hidden');
        });

		$(document).on('show.bs.collapse', '.landing-box', toggleLandingBox);

		$(document).on('hide.bs.collapse', '.landing-box', toggleLandingBox);
	}

	function toggleLandingBox() {
		var $el = $(this);
		var $parent = $el.closest('.landing');
		var isActive = $el.hasClass('in');
		var $btn = $parent.find('.btn-landing');
		var $icon = $btn.find('.icon');

		$btn[isActive ? 'removeClass' : 'addClass']('active');
		$icon[isActive ? 'addClass' : 'removeClass']('icon-1')[isActive ? 'removeClass' : 'addClass']('icon-2');
	}

	Global.LandingPage = LandingPage;
}(jQuery, window));